import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Toasted from 'vue-toasted'
import VueCookies from 'vue-cookies'
import VueHead from 'vue-head'
import vuetify from './plugins/vuetify'
import VueClipboard from 'vue-clipboard2'
import VueSession from 'vue-session'
import VueCountdownTimer from 'vuejs-countdown-timer'
import VueGtag from "vue-gtag"
import Croppa from 'vue-croppa'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

import '@/mixins/generalMixin'
import '@/mixins/ssoMixin'
import './registerServiceWorker'

Vue.config.productionTip = false

Vue.use(VueCookies)
Vue.use(VueSession)
Vue.use(VueCountdownTimer)
Vue.use(VueClipboard)
Vue.use(Croppa, { componentName: 'cropper' });
Vue.use(VueHead, {
  separator: '',
  complement: ''
})
Vue.use(Toasted, {
  position: 'bottom-center'
})
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })

Vue.use(VueGtag, {
  config: { 
    id: process.env.VUE_APP_NEWSHUB_GA_ACCOUNT,
    params: {
      send_page_view: false
    }
  }
});

// set default config
Vue.$cookies.config('1y','','',true,'None')

new Vue({
  router,
  store,
  vuetify,
  //VueCountdownTimer,
  render: h => h(App)
}).$mount('#app')